/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import { TouchableOpacity, View } from "react-native";
import Icon from "react-icons-kit";
import { closeRound } from "react-icons-kit/ionicons/closeRound";
import { Text } from "UpduoLibrary";
import { skalecalendarblue } from "config/UpduoColors";

interface FilterTagProps {
  text: string;
  onPress: () => void;
}

export default function FilterTag({ text, onPress }: FilterTagProps) {
  return (
    <View
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        paddingHorizontal: 15,
        backgroundColor: "#E4F0F9",
        height: 34,
        borderRadius: 4,
        marginRight: 16,
      }}
    >
      <Text
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: 22,
          fontStyle: "normal",
          fontWeight: "500",
          fontSize: 16,
          marginRight: 5,
        }}
      >
        {text}
      </Text>
      <TouchableOpacity
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 20,
          height: 20,
        }}
        onPress={onPress}
      >
        <Icon
          style={{ display: "flex", color: skalecalendarblue }}
          size={13}
          icon={closeRound}
        />
      </TouchableOpacity>
    </View>
  );
}
